export default {"src":"/_next/static/media/cover-default.c2050a8d.svg","height":265,"width":1792};